export const LIVE_DRAWING_SET_PATHS = 'LIVE_DRAWING_SET_PATHS';
export const LIVE_DRAWING_UPDATE_PATH = 'LIVE_DRAWING_UPDATE_PATH';
export const LIVE_DRAWING_END = 'LIVE_DRAWING_END';
